import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { MenuItem, Icon, IconButton } from '@material-ui/core';

import { Select, DateRangePicker, DateRangeStepper } from '../../../../components';
import { comparisonOptionNames } from '../../../../models';
import FilterWrapper from '../../filter-wrapper';

const styles = {
  dateRangePicker: {
    float: 'left',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  locationSelect: {
    marginTop: '10px',
  },
  sameLocation: {
    fontStyle: 'italic',
    color: '#808080',
  },
};

class ComparisonFilter extends Component {
  componentDidMount() {
    const { removeReportData, comparisonId } = this.props;
    removeReportData(comparisonId);
  }

  componentWillUnmount() {
    this.handleDelete();
  }

  handleSetLocation = (locationId) => {
    const {
      setComparisonDateRange, comparisonDateRange, removeReportData, comparisonId,
    } = this.props;

    if (comparisonDateRange.locationId !== locationId) {
      removeReportData(comparisonId);
      setComparisonDateRange({
        ...comparisonDateRange,
        locationId,
      });
    }
  }

  renderLocationSelect = () => {
    const {
      locations, selectedReport, comparisonDateRange, comparisonOption,
    } = this.props;

    if (!comparisonDateRange || !selectedReport || comparisonOption.name === comparisonOptionNames.none) {
      return null;
    }

    const { locationId, option } = comparisonDateRange;
    let locationsForThisReport = locations.filter(l => l.reports.some(r => r.reportID === selectedReport.reportID));

    const containsSelectedLocation = locationsForThisReport.find(l => l.id === locationId);
    if (locationId !== -1 && locationsForThisReport.length > 1 && option !== comparisonOptionNames.identical
      && !containsSelectedLocation) {
      this.handleSetLocation(locationsForThisReport[0].id);
    }

    if (!containsSelectedLocation && locationId !== -1) {
      locationsForThisReport = locationsForThisReport.concat(locations.find(l => l.id === locationId));
    }

    if (locationsForThisReport.length < 2) {
      return null;
    }

    const locationItems = locationsForThisReport.map(l => (
      <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
    ));

    return (
      <div style={styles.locationSelect}>
        <h3>Vergleich mit Lokal</h3>
        { locations && locationId
          && (
          <Select
            placeholder="Lokale"
            value={locationId}
            onChange={event => this.handleSetLocation(event.target.value)}
          >
            <MenuItem key="same" value={-1} style={styles.sameLocation}>Gleiches Lokal</MenuItem>
            {locationItems}
          </Select>
          )}
      </div>
    );
  }


  handleSetOption = (option) => {
    const {
      setComparisonDateRange, removeReportData, comparisonId, comparisonOptions, comparisonDateRange,
    } = this.props;

    // if the comparisonDateRange has no startTime and endTime and is set to custom use default values
    if (option === comparisonOptionNames.custom && (!comparisonDateRange.startTime || !comparisonDateRange.endTime)) {
      const comparisonOption = comparisonOptions.find(co => co.name === comparisonOptionNames.custom);

      setComparisonDateRange({
        ...comparisonDateRange,
        option,
        startDate: comparisonOption.startDate,
        endDate: comparisonOption.endDate,
      });
    } else {
      setComparisonDateRange({
        ...comparisonDateRange,
        option,
      });

      if (option === comparisonOptionNames.none) {
        removeReportData(comparisonId);
      }
    }
  }

  renderDateRangeSelect = () => {
    const { comparisonOptions, comparisonDateRange } = this.props;

    const selectedOption = comparisonDateRange
      ? comparisonDateRange.option
      : comparisonOptionNames.none;

    const optionItems = comparisonOptions.map(comparisonOption => (
      <MenuItem
        value={comparisonOption.name}
        key={comparisonOption.name}
      >
        {comparisonOption.name}
      </MenuItem>
    ));

    return (
      <div>
        <h3>Vergleichszeitraum</h3>
        <Select
          placeholder="Vergleichszeitraum"
          value={selectedOption}
          onChange={event => this.handleSetOption(event.target.value)}
        >
          {optionItems}
        </Select>
      </div>
    );
  }

  handleSetComparisonDateRange = (dateRange) => {
    const { setComparisonDateRange, comparisonDateRange } = this.props;

    setComparisonDateRange({
      ...comparisonDateRange,
      ...dateRange,
    });
  }

  renderDateRangePicker = () => {
    const { comparisonDateRange, comparisonOption } = this.props;

    if (!comparisonOption && !comparisonDateRange) {
      return null;
    }

    const { startDate, endDate } = comparisonOption.name === comparisonOptionNames.custom
      ? comparisonDateRange : comparisonOption;

    return (
      <div>
        { comparisonOption && comparisonOption.pickerVisible
        && (
          <DateRangePicker
            startDate={moment.unix(startDate)}
            endDate={moment.unix(endDate)}
            onDatesChanged={this.handleSetComparisonDateRange}
            styles={styles.dateRangePicker}
            disabled={comparisonOption && comparisonOption.pickerDisabled}
            title="Vergleichszeitraum"
          />
        )}
        { comparisonOption && !comparisonOption.pickerDisabled
        && (
          <DateRangeStepper
            startDate={moment.unix(startDate)}
            endDate={moment.unix(endDate)}
            onDatesChanged={this.handleSetComparisonDateRange}
          />
        )}
      </div>
    );
  }

  getNextComparisonId = () => {
    const { comparisonDateRanges } = this.props;
    return comparisonDateRanges[comparisonDateRanges.length - 1].comparisonId + 1;
  }

  handleAdd = () => {
    const { setComparisonDateRange, comparisonDateRange } = this.props;
    const nextComparisonId = this.getNextComparisonId();

    setComparisonDateRange({
      ...comparisonDateRange,
      comparisonId: nextComparisonId,
    });
  }

  renderAddButton = () => {
    const { comparisonOption } = this.props;
    const { pickerVisible } = comparisonOption || {};

    return (
      <div>
        {pickerVisible
        && <IconButton style={styles.plus} onClick={this.handleAdd}><Icon>add_circle</Icon></IconButton>}
      </div>
    );
  }

  handleDelete = () => {
    const {
      removeReportData, comparisonId, removeComparisonDateRange,
    } = this.props;

    removeComparisonDateRange(comparisonId);
    removeReportData(comparisonId);
  }

  renderDeleteButton = () => {
    const { isDeletable } = this.props;

    return (
      <div>
        {isDeletable
        && <IconButton style={styles.plus} onClick={this.handleDelete}><Icon>delete</Icon></IconButton>}
      </div>
    );
  }

  reset = () => {
    const {
      setComparisonDateRange, comparisonId, removeReportData, removeComparisonDateRange, isDeletable,
    } = this.props;

    removeReportData(comparisonId);

    if (isDeletable) {
      removeComparisonDateRange(comparisonId);
    } else {
      setComparisonDateRange({
        comparisonId,
        option: comparisonOptionNames.none,
        locationId: -1,
      });
    }
  }

  render() {
    const { isAdvancedFilter, comparisonDateRange } = this.props;

    return (
      <FilterWrapper
        style={styles.select}
        isAdvancedFilter={isAdvancedFilter}
        resetFilter={this.reset}
        isResetDisabled={comparisonDateRange.option === comparisonOptionNames.none}
      >
        {this.renderDateRangeSelect()}
        {this.renderDateRangePicker()}
        {this.renderLocationSelect()}
        <div style={styles.buttons}>
          {this.renderAddButton()}
          {this.renderDeleteButton()}
        </div>
      </FilterWrapper>
    );
  }
}

ComparisonFilter.propTypes = {
  isAdvancedFilter: PropTypes.bool,
  isDeletable: PropTypes.bool,
  comparisonId: PropTypes.number,
  comparisonOptions: PropTypes.array,
  comparisonDateRanges: PropTypes.array,
  locations: PropTypes.array,
  selectedReport: PropTypes.object,
  comparisonDateRange: PropTypes.object.isRequired,
  comparisonOption: PropTypes.object,
  setComparisonDateRange: PropTypes.func,
  removeComparisonDateRange: PropTypes.func,
  removeReportData: PropTypes.func,
};

ComparisonFilter.defaultProps = {
  isAdvancedFilter: false,
  isDeletable: false,
  comparisonId: 1,
  comparisonOptions: [],
  comparisonDateRanges: [],
  locations: [],
  selectedReport: {},
  comparisonOption: {},
  setComparisonDateRange: () => {},
  removeComparisonDateRange: () => {},
  removeReportData: () => {},
};

export default ComparisonFilter;
